const KeenSlider = window.KeenSlider

const { setInitialised, useGrabCursor, useArrows } =
  window.BAO.Carousel.plugins

class SubCollections extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'free',
        slides: {
          perView: 'auto',
          spacing: 10,
        },
      },
      [
        setInitialised(),
        useGrabCursor(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('sub-collections')) {
  customElements.define('sub-collections', SubCollections)
}
